<template>
  <div class="loading">
    <!-- <i class="el-icon-loading"></i> -->
    <!-- <div>{{ text }}</div> -->
    <el-button v-loading.lock="fullscreenLoading" class="btn"></el-button>
  </div>
</template>
<script>
export default {
  name: "Loading",
  props: {
    text: {
      type: String,
      default: "Loading...",
    },
  },
  data() {
    return {
      fullscreenLoading: true,
    };
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: $primary-color;
  z-index: 9999;
}
.btn {
  border: none !important;
  background: transparent !important;
}
/deep/ .el-loading-mask {
  background: transparent !important;
}
</style>
